import { useCheckout } from '~/composables/custom/useCheckout';
import useCheckoutForm from '~/composables/custom/useCheckoutForm';
import { CheckoutNavigationStatus } from '~/composables/custom/useCheckoutNavigation/useCheckoutNavigation';

const shippingInfo = ref(undefined);
export const useShippingNavigation = () => {
  const { updating } = useCheckout();
  const { isVisible } = useCheckoutForm('shipping');

  const nextState = computed(() => {
    if (updating.value) {
      return CheckoutNavigationStatus.LOADING;
    }

    return (Object.values(shippingInfo.value || {}).length > 1 || isVisible.value) ? CheckoutNavigationStatus.TO_PAYMENT : CheckoutNavigationStatus.MISSING_INFO;
  });

  return {
    nextState,
    resetShipping: () => { shippingInfo.value = undefined; },
    setShippingInfo: (value: any) => { shippingInfo.value = value; },
  };
};
